import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule }from '../../ng-zorro-antd/ng-zorro-antd.module';

import { ProgramaComponent } from './programa.component';
import { LancamentoProgramaComponent } from './lancamento-programa/lancamento-programa.component';
import { AutorizadorModule } from '../autorizador/autorizador.module';
import { NgxMaskPipe, NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [ProgramaComponent, LancamentoProgramaComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,    
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [provideNgxMask()],
})
export class ProgramaModule { }
